/**
 * Configuration centralisée pour les images statiques
 * Améliore la maintenance et la cohérence des chemins d'images
 */

export const STATIC_IMAGES = {
  // Images principales du booklet
  BOOKLET_COVER: 'Couv_UIC_Activity_Booklet_2024_ed5.jpg',
  DEFAULT_THEME: 'default-theme.jpg',

  // Images de base
  UIC_LOGO: 'uic_logo.svg',
  SAFETY_HUB_LOGO: 'safety_hub_orange.svg',
  WELCOME_BG: 'welcome_bg.svg',
  MASCOT: 'mascot.png',

  // Dossiers
  THEMES_DIR: '/images/themes/',
  ICONS_DIR: '/icons/',
  LOGOS_DIR: '/images/logos/',
} as const;

/**
 * Obtient le chemin d'une image depuis le dossier public
 * Pour les images qui ne sont pas dans le dossier /images/
 */
export function getPublicImagePath(imageName: string): string {
  return `/${imageName}`;
}

